/** The `returnTo` value of the sign-in page for a team invite (`/team/accept`). */
export const TEAM_ACCEPT_RETURN_TO = 'team/accept';
